import React from 'react'
import { AdvisorData, Advisor } from '../../utils/types'
import { trackEvent } from '../../utils/tracking/mixpanel'
import { useMatchScreen } from '../../context/MatchScreenContext'
import '../../styles/DisclosureModule/Disclosure.scss'

interface DisclosureModuleProps {
    advisors: AdvisorData[]
}

function textToHtml (content: string) {
  const markup = { __html: content }
  return <div dangerouslySetInnerHTML={markup} />
}

const DisclosureModule = ({ advisors }: DisclosureModuleProps) => {
  const defaultDisclosure = 'Advisor compensates SmartAsset for new leads. SmartAsset is not an investment client of Advisor. SmartAsset has an economic incentive to recommend Advisor, thereby resulting in a material conflict of interest.'
  const { state: { pageKey } } = useMatchScreen()

  const handleFeeStructureEvent = (advisor: Advisor) => {
    trackEvent('MatchScreen', 'FeeStructureClick', {
      page_key: pageKey,
      advisor_name: advisor.name,
      url: advisor.cpcustomlink ? advisor.cpcustomlink : '/disclosures/fee-structure/' + advisor.accountId
    })
  }
  return (
        <div className="disclosures_group">
            <b>Disclosures</b>
            <ol>
                {advisors.map(advisorDataEntry => (
                    <li key={advisorDataEntry.advisor.id} className="list_item">
                        <h3 className="name">{advisorDataEntry.advisor.name}</h3>
                        <b>
                            <div className="listing_disclosure">
                                <div>
                                    {advisorDataEntry.advisor.cpdisclosure ? textToHtml(advisorDataEntry.advisor.cpdisclosure) : defaultDisclosure}
                                </div>
                                <a
                                    href={advisorDataEntry.advisor.cpcustomlink ? advisorDataEntry.advisor.cpcustomlink : '/disclosures/fee-structure/' + advisorDataEntry.advisor.accountId}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={() => { handleFeeStructureEvent(advisorDataEntry.advisor) }}
                                >
                                    Details regarding fee structure can be found here.
                                </a>
                            </div>
                        </b>
                    </li>
                ))}
            </ol>
        </div>
  )
}

export default DisclosureModule
